import { render, staticRenderFns } from "./switchLayoutOneDialog.vue?vue&type=template&id=17121aa6&"
import script from "./switchLayoutOneDialog.vue?vue&type=script&lang=js&"
export * from "./switchLayoutOneDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchLayoutOneDialog.vue?vue&type=style&index=0&id=17121aa6&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports